import React, { useState, useEffect, memo } from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  InputBase,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
} from "@material-ui/core"
import bibleBookList from "../../data/BookChapterList.json"
import { getMetadata } from "../../scripts/getMetadata"
import { getTranslation } from "../../scripts/getTranslation"
import {useStore} from '../../teafuljs/store'

const useStyles = makeStyles(theme => ({
  formControl: {
    marginLeft: 0,
    marginTop: 10,
    marginBottom: 10,
    minWidth: 120,
    flex: 1,
  },
  select: {
    color: "black",
    WebkitAppearance: "none",
    textIndent: "1px",
    textAlign: "center",
    verticalAlign: "middle",
    textOverflow: "",
    "&:before": {
      WebkitAppearance: "none",
    },
    "&:after": {
      WebkitAppearance: "none",
    },
    marginTop: 10,
    borderBottom: "1px black solid",
    paddingLeft: 5,
  },
  icon: {
    fill: "black",
  },
  flag: {
    marginRight: 5,
  },
  menuItem: {
    position: "relative",
    display: "flex",
  },
  root: {
    flexGrow: 1,
    height: "auto",
  },
}))

const LanguageSelect = memo(
  ({
    location,
  }) => {
    const classes = useStyles()
  const translations = useStore.translations()[0]
  const AvailableContent = useStore.AvailableContent()[0]
  const [language, setLanguage] = useStore.language()
  const [version, setVersion] = useStore.version()
    const [searchID, setSearchID] = useStore.searchID()
    const [currentBook, setCurrentBook] = useStore.currentBook()
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID()
    const [metadata, setMetadata] = useStore.metadata();
    const [history, setHistory] = useStore.history();
    const [languageDisplay, updateLanguageDisplay] = useState(language)

    useEffect(() => {
      if (language !== languageDisplay) {
        updateLanguageDisplay(language)
      }
    }, [language])

    const getLangOptions = () => {
      let LanguageOptions = []
      const languageKeys = Object.keys(AvailableContent.content)
      languageKeys.forEach(key => {
        const langObj = {
          label: AvailableContent.content[key].language_name,
          value: key,
          language_code: AvailableContent.content[key].language_code,
        }
        LanguageOptions.push(langObj)
      })
      return LanguageOptions.sort(function(a, b) {
        var textA = a.label.toUpperCase()
        var textB = b.label.toUpperCase()
        return textA < textB ? -1 : textA > textB ? 1 : 0
      })
    }

    const getVersionOptions = langKey => {
      let VersionOptions = []
      const versionKeys = Object.keys(AvailableContent.content[langKey].versions)
      versionKeys.forEach(key => {
        console.log(key)
        const versionObj = {
          label: AvailableContent.content[langKey].versions[key],
          value: key,
        }
        VersionOptions.push(versionObj)
      })
      return VersionOptions.sort(function(a, b) {
        console.log(a, b)
        var textA = a.label.name.toUpperCase()
        var textB = b.label.name.toUpperCase()
        return textA < textB ? -1 : textA > textB ? 1 : 0
      })
    }

    function findFirstAvailableBook(language, version) {
      const booksInOrder = Object.keys(bibleBookList)
      let firstBook = ""
      booksInOrder.forEach(book => {
        if (
          AvailableContent.content[language][version][book] !== undefined &&
          firstBook === ""
        ) {
          firstBook = book
        }
      })
      return firstBook
    }

    const storeMetadata = async (language, version) => {
      const retrievedMetadata = await getMetadata(language, version)
      setMetadata(retrievedMetadata)
    }

    function handleChange(event) {
      setHistory([
        {
          page: location.pathname,
          language: language,
          version: version,
          segment: currentSegmentID,
          scrollY: window.scrollY,
        },
        ...history,
      ])
      const versionID = getVersionOptions(event.target.value)[0].value

      const currentSegmentExists =
        (AvailableContent.content[event.target.value][versionID][currentBook] &&
          AvailableContent.content[event.target.value][versionID][currentBook].segments.indexOf(
            currentSegmentID
          )) > -1 || false
      if (!currentSegmentExists) {
        const firstBookOfNewLanguage = findFirstAvailableBook(
          event.target.value,
          versionID
        )
        const firstSegmentOfNewLanguage =
          AvailableContent.content[event.target.value][versionID][firstBookOfNewLanguage]
            .segments[0]
        setCurrentSegmentID(firstSegmentOfNewLanguage)
        setCurrentBook(firstBookOfNewLanguage)
      }
      setLanguage(event.target.value)
      setVersion(versionID)
      storeMetadata(event.target.value, versionID)
      updateLanguageDisplay(event.target.value)
    }

    function getCountryFlag(cc) {
      // Mild sanity check.
      if (cc.length !== 2) return cc

      // Convert char to Regional Indicator Symbol Letter
      function risl(chr) {
        return String.fromCodePoint(
          0x1f1e6 - 65 + chr.toUpperCase().charCodeAt(0)
        )
      }

      // Create RISL sequence from country code.
      return risl(cc[0]) + risl(cc[1])
    }

    return (
      <div>
        {!AvailableContent.content ? null : (
          <form className={classes.root} autoComplete="off">
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel
                shrink
                id="demo-simple-select-placeholder-label-label"
              >
                {getTranslation(translations, language, "UI", "menu_language")}
              </InputLabel>
              <Select
                labelId="demo-simple-select-placeholder-label-label"
                id="demo-simple-select-placeholder-label"
                value={languageDisplay}
                onChange={handleChange}
                className={classes.select}
                inputProps={{
                  classes: {
                    icon: classes.icon,
                  },
                }}
                input={<InputBase className={classes.input} />}
              >
                {getLangOptions().map((language, index) => (
                  <MenuItem key={index} value={language.value}>
                    <span className={classes.flag}>
                      {getCountryFlag(language.language_code)}
                    </span>
                    <span>{language.label}</span>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </form>
        )}
      </div>
    )
  }
)

export default LanguageSelect
